import { render, staticRenderFns } from "./UseCode.vue?vue&type=template&id=b2be0e6c&"
import script from "./UseCode.vue?vue&type=script&lang=js&"
export * from "./UseCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2be0e6c')) {
      api.createRecord('b2be0e6c', component.options)
    } else {
      api.reload('b2be0e6c', component.options)
    }
    module.hot.accept("./UseCode.vue?vue&type=template&id=b2be0e6c&", function () {
      api.rerender('b2be0e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UseCode.vue"
export default component.exports